/* Re-anchor #fragment jumps after load: the Mapplic bundle rewrites the URL
   via history.pushState without the fragment, cancelling the browser's native
   anchor scroll, and its late layout shift moves the target. The fragment is
   read from the navigation timing entry because Mapplic may have already
   stripped it from location.hash by the time this runs. */
(function () {
  var nav =
    performance.getEntriesByType &&
    performance.getEntriesByType("navigation")[0];
  var match = ((nav && nav.name) || window.location.href).match(
    /#([A-Za-z0-9_-]+)$/
  );
  if (!match) return;
  var anchorId = match[1];

  var userScrolled = false;
  ["wheel", "touchstart", "keydown"].forEach(function (evt) {
    window.addEventListener(
      evt,
      function () {
        userScrolled = true;
      },
      { passive: true, once: true }
    );
  });

  window.addEventListener("load", function () {
    var target = document.getElementById(anchorId);
    if (!target) return;
    // Force any AOS entrance animation on the target to its settled state
    // before measuring: fade-up starts translated ~100px down, and scrolling
    // to the transformed position lands the section under the header once
    // the animation completes.
    if (target.hasAttribute("data-aos")) {
      target.classList.add("aos-init", "aos-animate");
    }
    [300, 1200].forEach(function (delay) {
      setTimeout(function () {
        if (!userScrolled) target.scrollIntoView();
      }, delay);
    });
  });
})();

window.addEventListener("scroll", function () {
  const SCROLL_THRESHOLD = 20;
  const headerElement = document.querySelector("header.header-site");

  if (!headerElement) {
    return;
  }

  headerElement.classList.toggle("scrolled", window.scrollY > SCROLL_THRESHOLD);
});

jQuery(document).ready(function ($) {
  $('[tabindex="0"]').keydown(function (event) {
    if (event.key === "Enter" || event.key === " ") {
      $(this).click();
    }
  });
});

/* Skip content */
document.addEventListener("DOMContentLoaded", function () {
  const linkGoSecondSection = document.getElementById("GoSecondSection");
  const secondSection = document.querySelector(
    ".general-section:nth-of-type(2)"
  );

  if (!linkGoSecondSection || !secondSection) return;

  linkGoSecondSection.addEventListener("click", function (event) {
    event.preventDefault();
    secondSection.scrollIntoView({ behavior: "smooth" });
  });
});

document.fonts.ready.then(function () {
  document.body.classList.add("font-loaded");
});

jQuery(document).ready(function ($) {
  jQuery(".content-main-cpt .wp-block-button .wp-block-button__link").each(
    function () {
      jQuery(this).append('<span class="icon-arrow-ic"></span>');
    }
  );
});

/* Search header */
jQuery(document).ready(function ($) {
  $(".toggle-search").on("click", function (e) {
    e.preventDefault();
    const $container = $(".search-container.desktop-form");
    const $form = $(".search-container.desktop-form .search-form");

    $form.slideToggle(200, function () {
      $container.toggleClass("active", $form.is(":visible"));

      if ($form.is(":visible")) {
        $form.find('input[name="s"]').focus();
      }
    });
  });

  $(".search-container.desktop-form .search-icon").on("click", function (e) {
    e.preventDefault();
    $(this).closest("form").submit();
  });

  $(".mobile-form .search-icon").on("click", function (e) {
    e.preventDefault();
    $(this).closest("form").submit();
  });
});

/**
 * Start-> Video side_by_side_card
 */
jQuery(document).ready(function ($) {
  $(".js-content-video-side-by-side-card .plyr-placeholder").on(
    "click",
    function () {
      const $wrapper = $(this).closest(".plyr-video-wrapper");
      const type = $wrapper.data("type");

      $(this).hide();

      let playerElement;

      if (type === "file") {
        const $video = $wrapper.find("video");
        $video.removeClass("is-hidden");
        playerElement = $video[0];
      } else if (type === "embed") {
        const $iframe = $wrapper.find("iframe");
        $iframe.removeClass("is-hidden");
        playerElement = $iframe[0];
      }

      const player = new Plyr(playerElement, {
        controls: [
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "settings",
          "fullscreen",
        ],
      });

      if (type === "file") {
        player.play();
      }
    }
  );
});

jQuery(document).ready(function ($) {
  const $videoCards = $(".js-content-video-side-by-side-card--file-and-embed");

  if ($videoCards.length === 0) return;

  $videoCards.each(function () {
    const $container = $(this);
    const $video = $container.find(".video-file");
    const videoEl = $video.get(0);
    const $playIcon = $container.find(".icon-video-side-by-side-card");

    if (!videoEl) return;

    const player = new Plyr(videoEl, {
      controls: [
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "fullscreen",
      ],
    });

    $container.removeClass("show-controls");

    $playIcon.on("click", function () {
      player.play();
    });

    videoEl.addEventListener("play", function () {
      $playIcon.hide();
      $container.addClass("show-controls");
    });

    videoEl.addEventListener("ended", function () {
      player.restart();
      player.pause();
      $container.removeClass("show-controls");
      $playIcon.show();
    });
  });
});

// Hide .navigation if the total is 1
jQuery(document).ready(function ($) {
  $(".ss-navigation").each(function () {
    const total = $(this).find(".ss-pagination-count .total").text().trim();
    if (total === "1") {
      $(this).hide();
    }
  });

  $(".swiper-pagination-fraction").each(function () {
    const total = $(this).find(".swiper-pagination-total").text().trim();
    if (total === "1") {
      $(this).hide();
    }
  });
});

// Tablepress responsive
document.addEventListener("DOMContentLoaded", function () {
  const tables = document.querySelectorAll(".tablepress");

  const tableStates = [];

  tables.forEach((table) => {
    // Tables can opt out of the mobile transpose via their TablePress
    // "Extra CSS classes" — flipping only suits tables with a handful of
    // rows, not row-per-country lists.
    if (
      table.classList.contains("no-responsive") ||
      table.classList.contains("disable-responsive")
    ) {
      return;
    }

    const tbody = table.querySelector("tbody");
    if (!tbody) return;

    const originalRows = Array.from(tbody.querySelectorAll("tr")).map((row) =>
      row.cloneNode(true)
    );

    tableStates.push({
      table,
      tbody,
      originalRows,
      isTransformed: false,
    });
  });

  function transformAllTables() {
    tableStates.forEach((state) => {
      const { tbody, originalRows } = state;

      if (window.innerWidth <= 991 && !state.isTransformed) {
        const maxColumns = 5;
        const newRows = [];

        for (let i = 1; i <= maxColumns; i++) {
          const newRow = document.createElement("tr");

          originalRows.forEach((row) => {
            const col = row.querySelector(`.column-${i}`);
            if (col) newRow.appendChild(col.cloneNode(true));
          });

          newRows.push(newRow);
        }

        tbody.innerHTML = "";
        newRows.forEach((row) => tbody.appendChild(row));
        state.isTransformed = true;
      } else if (window.innerWidth > 991 && state.isTransformed) {
        tbody.innerHTML = "";
        originalRows.forEach((row) => {
          tbody.appendChild(row.cloneNode(true));
        });
        state.isTransformed = false;
      }
    });
  }

  transformAllTables();

  window.addEventListener("resize", transformAllTables);
});

// Check for Analytics cookie consent
function isAnalyticsConsentGranted() {
  // Get the consent cookie
  const consentCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("cookieyes-consent="));

  if (!consentCookie) {
    return false; // Cookie not found - no consent given
  }

  // Extract the value (format may vary)
  const cookieValue = consentCookie.split("=")[1];

  try {
    // Cookieyes often stores JSON data in the cookie
    const consentData = JSON.parse(decodeURIComponent(cookieValue));

    // Check for analytics consent (structure may vary by configuration)
    if (consentData.consent && consentData.consent.analytics) {
      return consentData.consent.analytics === "yes";
    }

    // Alternative common structure
    if (consentData.categories && consentData.categories.analytics) {
      return consentData.categories.analytics === true;
    }
  } catch (e) {
    // If not JSON, check for simple string patterns
    return (
      cookieValue.includes("analytics:yes") ||
      cookieValue.includes("analytics=1")
    );
  }

  return false;
}

// Amplitude tracking on Self Serve page load. The Self-Serve view is the
// legacy /plans/self-serve page or the pricing page showing its Self-Serve
// audience (body classes from lib/pricing-page.php); on the pricing page
// the event also fires once when the visitor switches to Self-Serve.
jQuery(document).ready(function ($) {
  var tracked = false;
  function trackSelfServeView() {
    if (tracked) return;
    if (
      typeof window.amplitude !== "undefined" &&
      typeof window?.amplitude?.track !== "undefined" &&
      isAnalyticsConsentGranted()
    ) {
      tracked = true;
      window?.amplitude?.track("User Viewed Self-Serve Page");
    }
  }
  var body = document.body;
  if (
    window.location.pathname.includes("plans/self-serve") ||
    (body.classList.contains("pricing-page") && body.classList.contains("pricing-audience-self-serve"))
  ) {
    trackSelfServeView();
  }
  if (body.classList.contains("pricing-page")) {
    document.addEventListener("pricing:audience", function (e) {
      if (e.detail && e.detail.audience === "self-serve") trackSelfServeView();
    });
  }
});

// Amplitude tracking on station link clicks
jQuery(document).ready(function ($) {
  $('a[href*="station.veriff.com"]').on("click", function (e) {
    if (
      typeof window.amplitude !== "undefined" &&
      typeof window?.amplitude?.track !== "undefined" &&
      isAnalyticsConsentGranted()
    ) {
      window?.amplitude?.track("User Clicked Trial Button");
    }

    if (window.VeriffGeo) {
      const languageCode = jQuery("html").attr("lang").substring(0, 2);

      const translatedMessages = {
        en: "We’re sorry, but this service is not available in your location.",
        es: "Lo sentimos, pero este servicio no está disponible en su ubicación.",
        pt: "Lamentamos, mas este serviço não está disponível em sua localização.",
      };

      const $messageContainer = jQuery("#country-block-alert strong");

      $messageContainer.text(translatedMessages[languageCode]);

      // Function to set up blocking for restricted plans
      function setupLinkBlocking() {
        // Only proceed if the user is blocked
        if (VeriffGeo.isBlocked) {
          e.preventDefault();
          e.stopPropagation();

          // Show the blocked country alert
          $.magnificPopup.open({
            items: {
              src: "#country-block-alert",
              type: "inline",
            },
            midClick: true,
            mainClass: "mfp-fade",
            removalDelay: 300,
          });
        }
      }

      // If location already detected, set up blocking immediately
      if (VeriffGeo.isLocationDetected) {
        setupLinkBlocking();
      } else {
        // Otherwise wait for the detection event
        $(document).on("veriff:countryDetected", function () {
          setupLinkBlocking();
        });
      }
    } else {
      console.error("VeriffGeo module not found. Country blocking won't work.");
    }
  });
});

// Contact sales form fallback for privacy minded browsers
const $scriptElements = jQuery(
  "script[src='//js.hsforms.net/forms/embed/v2.js']"
);

if ($scriptElements.length > 0 && typeof window.hbspt !== "object") {
  const languageCode = jQuery("html").attr("lang").substring(0, 2);

  const translatedMessages = {
    en: "Your browser privacy settings are blocking the contact form. Please follow the link below and fill in the form there.",
    es: "Parece que la configuración de privacidad de tu navegador está impidiendo que se cargue el formulario de contacto. Por favor, haz clic en el enlace a continuación para llenar el formulario y poder contactarnos.",
    pt: "Parece que as configurações de privacidade do seu navegador estão impedindo o carregamento do formulário de contato. Por favor, clique no link abaixo para preencher o formulário e entrar em contato conosco.",
  };

  const formLinks = {
    en: "https://share.hsforms.com/1VVsGYdV_R4ODgXaGGgoqug5e0bd",
    es: "https://share.hsforms.com/16yMoeVBQSCWl6cDSfrQJMw5e0bd",
    pt: "https://share.hsforms.com/1NR64La-FTNyniewnY0HrOw5e0bd",
  };

  $scriptElements.each(function () {
    jQuery(this).parent(".iframe-content").find(":not(script)").remove();

    const nextElementText = jQuery(this).nextAll("script")[0].textContent;

    if (
      nextElementText.includes("555b0661-d57f-4783-8381-76861a0a2aba") ||
      nextElementText.includes("eb232879-5050-4825-a5e9-c0d27eb40933") ||
      nextElementText.includes("351eb82d-af85-4cdc-a789-ec276341eb3b")
    ) {
      const linkHref = formLinks[languageCode];
      const $parentContainer = jQuery(this).parent(".iframe-content");

      $parentContainer.append(
        `<p style='font-size: 16px'>${translatedMessages[languageCode]}</p>`
      );
      $parentContainer.append(
        `<a target='_blank' rel='noopener noreferrer' style='font-size: 16px; display: block; text-overflow: ellipsis; overflow: hidden;' href=${linkHref}>${linkHref}</a>`
      );
    }
  });
}
